export default __webpack_public_path__ + "static/media/Indepth.32b5cd8b.svg";